/**
 * Formats a number with as few decimal places as possible
 * This also does some rounding since the toFixed method rounds, so this can safely be used with unreliable floating point math as input
 * @param num The number to format
 * @param maxDecimalPlaces The number of decimal places to use if the number is a float. Defaults to 2 if not supplied
 * @returns A string representation of the number with {@link maxDecimalPlaces} decimal places if its a float
 */
export const formatNumberHumanReadableTrimZeroes = (num: number, maxDecimalPlaces?: number): string => {
    let returnNum = num % 1 === 0 ? num.toString() : num.toFixed(maxDecimalPlaces ?? 2);
    while (returnNum.includes('.') && (returnNum.endsWith('0') || returnNum.endsWith('.'))) {
        returnNum = returnNum.slice(0, -1);
    }
    return returnNum;
};

/**
 * Same as {@link formatNumberHumanReadableTrimZeroes} but returns a number instead of a string
 * @param num The number we want to round
 * @param decimalPlaces The number of decimalplaces we want to end up with
 * @returns A number rounded to {@link decimalPlaces} decimal places
 */
export const roundNumberHumanReadableTrimZeroes = (num: number, decimalPlaces?: number): number => {
    return num % 1 === 0 ? num : parseFloat(formatNumberHumanReadableTrimZeroes(num, decimalPlaces));
};
